<div *ngFor="let snackBar of snackBars" class="ir-snack-bar {{ snackBar.type }}">
  <div class="snack-bar-header"><a class="close" (click)="removeSnackBar(snackBar)">&times;</a></div>
  <div class="snack-bar-body">{{ snackBar.message }}</div>
</div>
